import { yupResolver } from '@hookform/resolvers/yup';
import {skipToken} from '@reduxjs/toolkit/query';
import moment from 'moment';
import { computeDeparture } from '../utils/stayTimes';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FormProvider, SubmitHandler, useForm, useWatch } from 'react-hook-form';
import {
  ActivityIndicator,
  Image,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { launchCamera } from 'react-native-image-picker';
import { Card, Divider } from 'react-native-paper';
import FontAwesome from '@react-native-vector-icons/fontawesome';
import { useSelector } from 'react-redux';
import * as yup from 'yup';
import { buildLogoUrl, ShowToast } from '../Common/common';
import BTButton from '../Components/BTButton';
import BTComboBox from '../Components/BTComboBox';
import { BTDateTimePicker } from '../Components/BTDateTimePicker';
import { Col, Row } from '../Components/BTGrid';
import { TextInput } from '../Components/BTTextInput';
import { useGetModesQuery } from '../redux/services/amodeApi';
import { useGetStatesQuery } from '../redux/services/astateApi';
import { useGetAddressMutation } from '../redux/services/foeaddrbookApi';
import {
  useGetFOECheckinByIdQuery,
  useGetFOEMobileQuery,
  useInsertFOECheckinMutation,
  useUpdateFOECheckinMutation,
} from '../redux/services/foecheckinApi';
import { useGetFOMHeadsQuery } from '../redux/services/fomheadApi';
import { useGetFOMIdtypesQuery } from '../redux/services/fomidtypeApi';
import { useGetFOMSourcesQuery } from '../redux/services/fomsourceApi';
import {
  useGetFOVacantRoomsEdQuery,
  useGetFORoomssQuery,
} from '../redux/services/foroomsApi';
import {
  useGetFORoomTariffDetailsQuery,
  useGetFORoomTariffsQuery,
} from '../redux/services/foroomtariffApi';
import { useGetFOSettingByIdQuery } from '../redux/services/foasettingApi';
import { useGetEmployeesQuery } from '../redux/services/emmemployeeApi';
import { RootState } from '../redux/store';
import styles from '../styles/FOStyles';
import CheckinGRC from './Print/CheckinGRC';
import AdvanceReceipt from './Print/AdvanceReceipt';
import { findHeadByTariff } from '../Common/headUtils';

import T from '../Components/T';
import { tp } from '../utils/translateText';
const isTenDigitMobile = (value: unknown): boolean =>
  /^\d{10}$/.test(String(value ?? '').trim());

// Validation Schema
const validationSchema = yup.object({
  // Required only when FO setting se_hkempcheckin = 1 (yup context)
  ci_employee: yup
    .number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? null : value,
    )
    .when('$hkEmpRequired', {
      is: true,
      then: schema =>
        schema.test(
          'hk-employee-required',
          'Housekeeping Employee is required for Check-in',
          value => Number(value) > 0,
        ),
      otherwise: schema => schema.optional(),
    }),
  ab_mobile: yup.string().required('Mobile Number is required'),
  ab_name: yup.string().required('Guest Name is required'),
  ci_details: yup.array().of(
    yup.object().shape({
      cd_roomtype: yup
        .number()
        .min(1, 'Room Type is Reequired')
        .required('Room Type is required')
        .typeError('Room Type is required'),
      cd_room: yup
        .number()
        .min(1, 'Room No is required')
        .required('Room No is required')
        .typeError('Room No is required'),
      cd_male: yup
        .number()
        .required('Male is required')
        .typeError('Male is required'),
      cd_female: yup
        .number()
        .required('FeMale is required')
        .typeError('FeMale is required'),
      cd_child: yup
        .number()
        .required('Child is required')
        .typeError('Child is required'),
      cd_rate: yup
        .number()
        .required('Tariff is required')
        .typeError('Tariff is required'),
      cd_amt: yup
        .number()
        .required('Tariff is required')
        .typeError('Tariff is required'),
    }),
  ),
});
const CheckInForm = ({ navigation, route }: UniversalProps) => {
  const gdata = useSelector((state: RootState) => state.gdata);
  const cid = gdata.company;
  const [isFront, setIsFront] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [mobile, setMobile] = useState('');
  const [selectedRooms, setSelectedRooms] = useState<number[]>([]);
  const [file, setFile] = useState<any>(null);
  const [file1, setFile1] = useState<any>(null);
  const [image1Uri, setImage1Uri] = useState('');
  const [image2Uri, setImage2Uri] = useState('');
  const [photoUri, setPhotoUri] = useState('');
  const [apiCall, setApiCall] = useState(false);
  const editCheckinId = Number(
    route.params?.checkinId || route.params?.ci_id || 0,
  );
  const isEditMode = editCheckinId > 0;

  const [insertCheckIn] = useInsertFOECheckinMutation();
  const [updateCheckIn] = useUpdateFOECheckinMutation();
  const [getAddressDetails] = useGetAddressMutation();
  const { data: sourceData } = useGetFOMSourcesQuery(cid);
  const { data: typeData } = useGetFORoomTariffsQuery(cid);
  const { data: roomData } = useGetFORoomssQuery(cid);
  const { data: editRoomData } = useGetFOVacantRoomsEdQuery(
    { cid, checkin: editCheckinId },
    { skip: !isEditMode },
  );
  const { data: modeData } = useGetModesQuery(cid);
  const { data: headData } = useGetFOMHeadsQuery(cid);
  const { data: foSetting } = useGetFOSettingByIdQuery(cid);
  const { data: employeeData } = useGetEmployeesQuery(cid);
  const employees = employeeData?.map((item: any) => ({
    id: item.em_id,
    label: `${item.em_name} (${item.em_code || ''})`.trim(),
  }));
  const {
    data: editCheckinData,
    isFetching: isEditCheckinFetching,
    isError: isEditCheckinError,
  } = useGetFOECheckinByIdQuery(
    isEditMode ? String(editCheckinId) : skipToken,
    {
      refetchOnFocus: true,
    },
  );
  const { data: guestDetails } = useGetFOEMobileQuery(
    { cid: cid, mobile: mobile },
    { skip: isEditMode || !isTenDigitMobile(mobile) },
  );
  const { data: tariffData } = useGetFORoomTariffDetailsQuery(cid);
  const { data: idtypeData } = useGetFOMIdtypesQuery(cid);
  const { data: stateData } = useGetStatesQuery();

  const modes: any = modeData?.map((value, key) => {
    return {
      label: value.md_name,
      id: value.md_id,
      value: value,
    };
  });

  const types = typeData?.map(value => {
    return {
      label: value.rt_name,
      id: value.rt_id,
      value: value,
    };
  });

  const idTypes = idtypeData?.map((value, key) => {
    return {
      label: value.it_name,
      id: value.it_id,
      value: value,
    };
  });

  const roomOptionsData = isEditMode ? editRoomData : roomData;
  const rooms = roomOptionsData
    ?.filter(v => isEditMode || v.rm_status === 'V')
    ?.map(value => ({
      label: `${value.rm_name} - (${value.rt_name})`,
      id: value.rm_id,
    }));

  const createNewRoom = (srid: number) => ({
    cd_id: 0,
    cd_srid: srid,
    cd_roomtype: 0,
    cd_room: 0,
    cd_adult: 0,
    cd_extadult: 0,
    cd_extchild: 0,
    cd_male: 0,
    cd_female: 0,
    cd_child: 0,
    cd_plan: 0,
    cd_rate: 0,
    cd_plrate: 0,
    cd_earate: 0,
    cd_ecrate: 0,
    cd_tax1: 0,
    cd_tax1per: 0,
    cd_tax1amt: 0,
    cd_tax2: 0,
    cd_tax2per: 0,
    cd_tax2amt: 0,
    cd_tax3: 0,
    cd_tax3per: 0,
    cd_tax3amt: 0,
    cd_discper: 0,
    cd_discamt: 0,
    cd_amt: 0,
    cd_flag: '0',
    cd_rentaltype: 'D',
    cd_hours: 0,
    cd_minhours: 0,
    cd_baserent: 0,
    cd_interval: 1,
    cd_unitrate: 0,
    cd_refreshhours: 0,
    cd_refreshrate: 0,
    cd_interval24: 0,
    cd_hourlyrate24: 0,
    cd_extrabedinterval: 0,
    cd_hourlyeachrg: 0,
    cd_extrabedinterval24: 0,
    cd_hourlyeachrg24: 0,
  });

  // Duplicated from ui/src/screens/pages/Transaction/FOCheckin/roomHelpers.ts -
  // there is no shared package between ui/ and app/ (plan section 5), consistent
  // with the existing full duplication of redux/services/* between the two apps.
  const calculateHourlyAmount = (
    stayedHours: number,
    minHours: number,
    baseRent: number,
    interval: number,
    ratePerInterval: number,
  ): number => {
    const safeMinHours = minHours > 0 ? minHours : 0;
    const safeInterval = interval > 0 ? interval : 1;
    if (safeMinHours === 0) {
      return Math.ceil(stayedHours / safeInterval) * ratePerInterval;
    }
    if (stayedHours <= safeMinHours) {
      return baseRent;
    }
    const extraIntervals = Math.ceil(
      (stayedHours - safeMinHours) / safeInterval,
    );
    return baseRent + extraIntervals * ratePerInterval;
  };

  /**
   * Rental types selectable for a room type, gated by company toggle + tariff-row
   * data. Mirrors FOCheckin/logic.tsx's getAvailableRentalTypes (web), including the
   * section 6.2 requirement that Refreshment only appears with a billable Hourly
   * fallback on the same row.
   */
  const getAvailableRentalTypesForRoomType = (roomTypeId: number) => {
    const options: { label: string; id: string }[] = [];
    const roomTariffs = tariffData?.filter(t => t.rt_id === roomTypeId) || [];
    const hasDaily = roomTariffs.some(t => Number(t.rd_rate) > 0);
    const hasHourly = roomTariffs.some(t => Number(t.rd_hourlyrate) > 0);
    const hasRefreshment = roomTariffs.some(
      t =>
        Number(t.rd_refreshrate) > 0 &&
        Number(t.rd_refreshhours) > 0 &&
        Number(t.rd_hourlyrate) > 0,
    );
    if (Number(gdata.rentaldaily ?? 1) !== 0 && (hasDaily || roomTariffs.length === 0))
      options.push({label: 'Daily', id: 'D'});
    if (Number(gdata.rentalhourly ?? 0) !== 0 && hasHourly)
      options.push({label: 'Hourly', id: 'H'});
    if (Number(gdata.rentalrefreshment ?? 0) !== 0 && hasRefreshment)
      options.push({label: 'Refreshment', id: 'R'});
    return options.length > 0 ? options : [{label: 'Daily', id: 'D'}];
  };

  /**
   * Sets cd_rentaltype/cd_rate and the snapshot fields for a detail row, and (for
   * Hourly/Refreshment) extends the shared ci_depature by the tariff's threshold
   * from "now" - mobile has no arrival/departure time picker (plan section 5), so
   * the actual duration is only known for certain once the guest is checked out;
   * this just seeds a sane initial value the same way check-in defaults to "now
   * + 1 day" for Daily today.
   */
  const applyRentalType = (index: number, rentalType: string, matched: any) => {
    methods.setValue(`ci_details.${index}.cd_rentaltype`, rentalType);
    if (rentalType === 'H') {
      const minHours = Number(matched?.rd_minhours ?? 1);
      const baseRent = Number(matched?.rd_baserent ?? 0);
      const interval = Number(matched?.rd_interval ?? 1);
      const hourlyRate = Number(matched?.rd_hourlyrate ?? 0);
      methods.setValue(`ci_details.${index}.cd_minhours`, minHours.toString());
      methods.setValue(`ci_details.${index}.cd_baserent`, baseRent.toString());
      methods.setValue(`ci_details.${index}.cd_interval`, interval.toString());
      methods.setValue(`ci_details.${index}.cd_unitrate`, hourlyRate.toString());
      methods.setValue(`ci_details.${index}.cd_interval24`, Number(matched?.rd_interval24 ?? 0).toString());
      methods.setValue(`ci_details.${index}.cd_hourlyrate24`, Number(matched?.rd_hourlyrate24 ?? 0).toString());
      methods.setValue(`ci_details.${index}.cd_extrabedinterval`, Number(matched?.rd_extrabedinterval ?? 0).toString());
      methods.setValue(`ci_details.${index}.cd_hourlyeachrg`, Number(matched?.rd_hourlyeachrg ?? 0).toString());
      methods.setValue(`ci_details.${index}.cd_extrabedinterval24`, Number(matched?.rd_extrabedinterval24 ?? 0).toString());
      methods.setValue(`ci_details.${index}.cd_hourlyeachrg24`, Number(matched?.rd_hourlyeachrg24 ?? 0).toString());
      methods.setValue(`ci_details.${index}.cd_refreshhours`, '0');
      methods.setValue(`ci_details.${index}.cd_refreshrate`, '0');
      methods.setValue(`ci_details.${index}.cd_hours`, minHours.toString());
      const rate = calculateHourlyAmount(minHours, minHours, baseRent, interval, hourlyRate);
      methods.setValue(`ci_details.${index}.cd_rate`, rate.toString());
      methods.setValue(`ci_details.${index}.cd_amt`, rate.toString());
      const arrival = moment();
      methods.setValue('ci_arrvial', arrival.format('YYYY-MM-DD HH:mm:ss'));
      methods.setValue('ci_depature', arrival.clone().add(minHours, 'hours').format('YYYY-MM-DD HH:mm:ss'));
      methods.setValue('ci_days', 0);
    } else if (rentalType === 'R') {
      const refreshHours = Number(matched?.rd_refreshhours ?? 1);
      const refreshRate = Number(matched?.rd_refreshrate ?? 0);
      methods.setValue(`ci_details.${index}.cd_refreshhours`, refreshHours.toString());
      methods.setValue(`ci_details.${index}.cd_refreshrate`, refreshRate.toString());
      methods.setValue(`ci_details.${index}.cd_minhours`, Number(matched?.rd_minhours ?? 1).toString());
      methods.setValue(`ci_details.${index}.cd_baserent`, Number(matched?.rd_baserent ?? 0).toString());
      methods.setValue(`ci_details.${index}.cd_interval`, Number(matched?.rd_interval ?? 1).toString());
      methods.setValue(`ci_details.${index}.cd_unitrate`, Number(matched?.rd_hourlyrate ?? 0).toString());
      methods.setValue(`ci_details.${index}.cd_hours`, refreshHours.toString());
      methods.setValue(`ci_details.${index}.cd_rate`, refreshRate.toString());
      methods.setValue(`ci_details.${index}.cd_amt`, refreshRate.toString());
      const arrival = moment();
      methods.setValue('ci_arrvial', arrival.format('YYYY-MM-DD HH:mm:ss'));
      methods.setValue('ci_depature', arrival.clone().add(refreshHours, 'hours').format('YYYY-MM-DD HH:mm:ss'));
      methods.setValue('ci_days', 0);
    } else {
      const rate = Number(matched?.rd_rate ?? 0);
      methods.setValue(`ci_details.${index}.cd_minhours`, '0');
      methods.setValue(`ci_details.${index}.cd_baserent`, '0');
      methods.setValue(`ci_details.${index}.cd_interval`, '1');
      methods.setValue(`ci_details.${index}.cd_unitrate`, '0');
      methods.setValue(`ci_details.${index}.cd_refreshhours`, '0');
      methods.setValue(`ci_details.${index}.cd_refreshrate`, '0');
      methods.setValue(`ci_details.${index}.cd_hours`, '0');
      methods.setValue(`ci_details.${index}.cd_rate`, rate.toString());
      methods.setValue(`ci_details.${index}.cd_amt`, rate.toString());
    }
  };

  let initialValues: any = {
    ab_id: 0,
    ab_company: cid,
    ab_mobile: '',
    ab_name: 'Mr. ',
    ab_addr1: '',
    ab_addr2: '',
    ab_city: '',
    ab_state: gdata.defstate,
    ab_country: gdata.defcountry,
    ab_pincode: '',
    ab_dob: moment().toDate(),
    ab_age: 0,
    ab_phone: '',
    ab_email: '',
    ab_from: '',
    ab_purpose: gdata.defpurpose,
    ab_idtype: gdata.defidtype,
    ab_idno: '',
    ab_cname: '',
    ab_caddr: '',
    ab_dept: '',
    ab_tax1no: '',
    ab_tax2no: '',
    ab_tax3no: '',
    ab_type: 1,
    ab_salesteam: 1,
    ab_newspaper: 1,
    ab_vehicleno: '',
    ab_uid: '',
    ab_cdt: moment().format('YYYY-MM-DD HH:mm:ss'),
    ab_muid: '',
    ab_mdt: moment().format('YYYY-MM-DD HH:mm:ss'),
    ci_id: 0,
    ci_company: cid,
    ci_date:
      moment(gdata.today).format('YYYY-MM-DD') + moment().format(' HH:mm:ss'),
    ci_no: '',
    ci_source: gdata.defsource,
    ci_reservation: 0,
    ci_gcompany: 0,
    ci_guest: 0,
    ci_mobile: '',
    ci_name: '',
    ci_email: '',
    ci_arrvial: moment().format('YYYY-MM-DD HH:mm:ss'),
    ci_depature: computeDeparture(
      moment(),
      1,
      gdata,
      false,
      Number(gdata.default24h) === 1
    ).format('YYYY-MM-DD HH:mm:ss'),
    ci_is24hrs: Number(gdata.default24h) === 1 ? 1 : 0,
    ci_days: 1,
    ci_rcptno: '',
    ci_advamt: 0,
    ci_mode: gdata.defmode,
    ci_refno: '',
    ci_refdt: moment().format('YYYY-MM-DD HH:mm:ss'),
    ci_refbank: '',
    ci_remarks: '',
    ci_employee: 0,
    ci_flag: '1',
    ci_uid: gdata.user,
    ci_cdt: moment().format('YYYY-MM-DD HH:mm:ss'),
    ci_muid: gdata.user,
    ci_mdt: moment().format('YYYY-MM-DD HH:mm:ss'),
    ci_details: [createNewRoom(1)],
    gr_id: 0,
    gr_company: cid,
    gr_no: '',
    gr_date:
      moment(gdata.today).format('YYYY-MM-DD') + moment().format(' HH:mm:ss'),
    gr_checkin: 0,
    ot_id: 0,
    ot_no: '',
    ot_date: moment(gdata.today).format('YYYY-MM-DD'),
    ot_days: 1,
    ot_rooms: 1,
    ot_tariff: 0,
    ot_eb: 0,
    ot_tax: 0,
    ot_gross: 0,
    ot_net: 0,
    ot_comm: 20,
    ot_commamt: 0,
    ot_ctax: 18,
    ot_ctaxamt: 0,
    ot_commision: 0,
    ot_tcs: 1,
    ot_tcsamt: 0,
    ot_tds: 1,
    ot_tdsamt: 0,
    ci_plan: gdata.defplan,
    ci_rooms: 1,
    cd_discper: 0,
  };

  const methods = useForm<any>({
    defaultValues: initialValues,
    resolver: (values, context, options) =>
      yupResolver(validationSchema)(
        values,
        {...context, hkEmpRequired: foSetting?.se_hkempcheckin === 1},
        options,
      ),
  });
  const hydratedCheckinIdRef = useRef<number | null>(null);
  // Guards the tax/net recalculation watch (below) from firing during
  // methods.reset() in edit mode — the saved record's cd_amt/cd_tax*amt are the
  // real as-billed values and must not be recomputed against current tariff
  // brackets just because reset() touches those fields.
  const isHydratingRef = useRef(false);
  const watchedDetails = useWatch({
    control: methods.control,
    name: 'ci_details',
  });
  const detailRows =
    watchedDetails && watchedDetails.length > 0
      ? watchedDetails
      : methods.getValues('ci_details') || [];

  const normalizeDob = (value: any) => {
    const parsed = moment(value);
    return parsed.isValid() ? parsed.toDate() : moment().toDate();
  };

  const normalizeCheckinForForm = (checkin: any) => {
    const normalizedDetails =
      checkin?.ci_details && checkin.ci_details.length > 0
        ? checkin.ci_details.map((detail: any, index: number) => ({
            ...createNewRoom(Number(detail.cd_srid || index + 1)),
            ...detail,
            cd_id: Number(checkin.ci_id || editCheckinId),
            cd_srid: Number(detail.cd_srid || index + 1),
            cd_roomtype: Number(detail.cd_roomtype || 0),
            cd_room: Number(detail.cd_room || 0),
          }))
        : [createNewRoom(1)];

    return {
      ...initialValues,
      ...checkin,
      ci_id: Number(checkin.ci_id || editCheckinId),
      ci_company: cid,
      ci_mobile: checkin.ci_mobile || checkin.ab_mobile || '',
      ci_details: normalizedDetails,
      ab_company: cid,
      ab_dob: normalizeDob(checkin.ab_dob),
      gr_company: cid,
      gr_checkin: Number(checkin.gr_checkin || checkin.ci_id || editCheckinId),
      ot_id: Number(checkin.ot_id || checkin.ci_id || editCheckinId),
    };
  };

  useEffect(() => {
    if (guestDetails && guestDetails.length > 0) {
      const g = guestDetails[0];
      const fields: any = {
        ci_guest: g.ab_id,
        ab_id: g.ab_id,
        ab_mobile: g.ab_mobile,
        ab_name: g.ab_name,
        ab_addr1: g.ab_addr1,
        ab_addr2: g.ab_addr2,
        ab_city: g.ab_city,
        ab_state: g.ab_state,
        ab_country: g.ab_country,
        ab_pincode: g.ab_pincode,
        ab_dob: moment(g.ab_dob).toDate(),
        ab_age: g.ab_age,
        ab_phone: g.ab_phone,
        ab_email: g.ab_email,
        ab_from: g.ab_from,
        ab_purpose: g.ab_purpose,
        ab_idtype: g.ab_idtype,
        ab_idno: g.ab_idno,
        ab_cname: g.ab_cname,
        ab_caddr: g.ab_caddr,
        ab_dept: g.ab_dept,
        ab_tax1no: g.ab_tax1no,
        ab_tax2no: g.ab_tax2no,
        ab_tax3no: g.ab_tax3no,
        ab_type: g.ab_type,
        ab_salesteam: g.ab_salesteam,
        ab_newspaper: g.ab_newspaper,
        ab_vehicleno: g.ab_vehicleno,
      };
      Object.keys(fields).forEach(key => methods.setValue(key, fields[key]));
    }
  }, [guestDetails, isEditMode]);

  const calculateNetAmount = useCallback(
    (index?: number, field?: string) => {
      const details = methods.getValues('ci_details') || [];

      details.forEach((detail: any, i: number) => {
        if (index !== undefined && i !== index) return;

        let rate = Number(detail.cd_rate) || 0;
        let ea = Number(detail.cd_earate) || 0;

        const currentTaxBase = rate + ea;
        const matchedHead = findHeadByTariff(currentTaxBase, 1, headData);

        let tax1per = matchedHead ? Number(matchedHead.hd_tax1per) : 0;
        let tax2per = matchedHead ? Number(matchedHead.hd_tax2per) : 0;

        const finalTaxBase = rate + ea;
        const tax1amt = Math.fround((finalTaxBase * tax1per) / 100);
        const tax2amt = Math.fround((finalTaxBase * tax2per) / 100);
        const calculatedNet = finalTaxBase + tax1amt + tax2amt;

        const updateField = (name: string, newVal: any, isSource: boolean) => {
          const currentVal = methods.getValues(name);
          if (Number(currentVal).toFixed(2) !== Number(newVal).toFixed(2)) {
            methods.setValue(
              name,
              isSource ? newVal.toString() : newVal.toFixed(2),
            );
          }
        };

        methods.setValue(`ci_details.${i}.cd_tax1`, '1');
        if (
          methods.getValues(`ci_details.${i}.cd_tax1per`) !== tax1per.toString()
        ) {
          methods.setValue(`ci_details.${i}.cd_tax1per`, tax1per.toString());
        }
        updateField(`ci_details.${i}.cd_tax1amt`, tax1amt, false);

        methods.setValue(`ci_details.${i}.cd_tax2`, '1');
        if (
          methods.getValues(`ci_details.${i}.cd_tax2per`) !== tax2per.toString()
        ) {
          methods.setValue(`ci_details.${i}.cd_tax2per`, tax2per.toString());
        }
        updateField(`ci_details.${i}.cd_tax2amt`, tax2amt, false);

        updateField(`ci_details.${i}.cd_amt`, calculatedNet, false);
      });
    },
    [methods, headData],
  );

  // Keeps tax/net in sync when the front-desk staff manually edits Tariff, Extra Bed
  // rate, or Room Type after a room has already been selected. Without this, cd_amt
  // (Net) is a plain editable TextInput with nothing enforcing that it actually
  // reflects the entered Tariff — bills/receipts would print a stale Net amount.
  // Guarded by isHydratingRef so it doesn't fire during methods.reset() when loading
  // an existing check-in for editing (see the comment at that reset() call).
  useEffect(() => {
    const subscription = methods.watch((_, { name }) => {
      if (isHydratingRef.current) return;
      if (name?.startsWith('ci_details')) {
        const match = name.match(/ci_details\.(\d+)\.(.+)/);
        if (match) {
          const index = parseInt(match[1], 10);
          const fieldName = match[2];
          // cd_amt itself is excluded — it's a calculated output, not an input.
          if (['cd_rate', 'cd_earate', 'cd_roomtype'].includes(fieldName)) {
            calculateNetAmount(index, fieldName);
          }
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [methods, calculateNetAmount]);

  const onInvalidSubmit = (errors: any) => {
    const message =
      errors?.ci_employee?.message ||
      errors?.ab_mobile?.message ||
      errors?.ab_name?.message ||
      'Please fill all required fields correctly';
    ShowToast(message, 'error');
  };

  useEffect(() => {
    if (!isEditMode || !editCheckinData || typeof editCheckinData !== 'object') {
      return;
    }

    const loadedId = Number(editCheckinData.ci_id || editCheckinId);
    if (hydratedCheckinIdRef.current === loadedId) {
      return;
    }

    const formValues = normalizeCheckinForForm(editCheckinData);
    isHydratingRef.current = true;
    methods.reset(formValues);
    isHydratingRef.current = false;
    setSelectedRooms(
      formValues.ci_details
        .map((detail: any) => Number(detail.cd_room || 0))
        .filter((roomId: number) => roomId > 0),
    );
    setMobile('');
    setFile(null);
    setFile1(null);
    setImage1Uri(editCheckinData.file || '');
    setImage2Uri(editCheckinData.file1 || '');
    setPhotoUri(editCheckinData.photo || '');
    // Do not recalculate tax/net here: the saved record already has the correct,
    // as-billed cd_tax1amt/cd_tax2amt/cd_amt. Recomputing against current fo_mhead
    // brackets (and racing headData's own load) would overwrite/zero real billed data.
    hydratedCheckinIdRef.current = loadedId;
  }, [editCheckinData, editCheckinId, isEditMode, methods]);

  const toggleCamera = () => {
    setIsFront(prev => !prev);
  };

  const [, setDetailsTick] = useState(0);

  useEffect(() => {
    if (!isEditMode && route.params?.room) {
      const roomId = Number(route.params?.room);
      methods.setValue('ci_details.0.cd_room', Number(roomId));
      setSelectedRooms(roomId ? [roomId] : []);
      methods.setValue(`ci_details.0.cd_room`, roomId);

      const matched = tariffData?.find(
        t =>
          t.rf_roomtype ===
          roomData?.find(v => v.rm_id === roomId)?.rm_roomtype,
      );

      if (matched) {
        methods.setValue(`ci_details.0.cd_roomtype`, matched.rt_id.toString());
        methods.setValue(`ci_details.0.cd_male`, matched.rf_occ.toString());
        methods.setValue(`ci_details.0.cd_female`, '0');
        methods.setValue(`ci_details.0.cd_child`, '0');
        methods.setValue(`ci_details.0.cd_adult`, matched.rf_occ.toString());
        methods.setValue(`ci_details.0.cd_earate`, '0');
        applyRentalType(0, 'D', matched);

        calculateNetAmount();
      }
    }
  }, [route.params, methods, tariffData, isEditMode, roomData]);

  const handleAddRoom = () => {
    const currentDetails = methods.getValues('ci_details');
    const nextSrid =
      Math.max(0, ...currentDetails.map((d: any) => d.cd_srid || 0)) + 1;
    methods.setValue(
      'ci_details',
      [...currentDetails, createNewRoom(nextSrid)],
      { shouldDirty: true },
    );
    setDetailsTick(t => t + 1);
  };

  const formatDateForBackend = (dateValue: any): string => {
    if (!dateValue) return moment().format('YYYY-MM-DD HH:mm:ss');

    // Handle Date objects
    if (dateValue instanceof Date) {
      return moment(dateValue).format('YYYY-MM-DD HH:mm:ss');
    }

    // If it's already a string, try parsing with multiple formats
    if (typeof dateValue === 'string') {
      // Normalize the string (trim and normalize spaces)
      const normalized = dateValue.trim().replace(/\s+/g, ' ');

      // Try parsing with different formats (with and without time)
      const formats = [
        'YYYY-MM-DD HH:mm:ss',
        'YYYY/MM/DD HH:mm:ss',
        'YYYY-MM-DD',
        'YYYY/MM/DD',
      ];

      let parsedDate = moment(normalized, formats, true);

      // If strict parsing failed, try loose parsing (moment's auto-detection)
      if (!parsedDate.isValid()) {
        parsedDate = moment(normalized);
      }

      // If still invalid, return current date
      if (!parsedDate.isValid()) {
        console.warn(`Invalid date format: ${dateValue}, using current date`);
        return moment().format('YYYY-MM-DD HH:mm:ss');
      }

      return parsedDate.format('YYYY-MM-DD HH:mm:ss');
    }

    // For any other type, try moment parsing
    const parsedDate = moment(dateValue);
    if (parsedDate.isValid()) {
      return parsedDate.format('YYYY-MM-DD HH:mm:ss');
    }

    // Fallback to current date
    console.warn(`Could not parse date: ${dateValue}, using current date`);
    return moment().format('YYYY-MM-DD HH:mm:ss');
  };

  const onSubmit: SubmitHandler<any> = async values => {
    if (isSaving) return;

    if (foSetting?.se_manualreceipt === 1 && Number(values.ci_advamt) > 0) {
      const hasRef = String(values.ci_remarks || values.ci_refno || '').trim().length > 0;
      if (!hasRef) {
        ShowToast('Manual Receipt No / Reference is required when advance amount is entered', 'error');
        return;
      }
    }

    setIsSaving(true);

    try {
      // Format dates to YYYY-MM-DD HH:mm:ss format for backend
      const formattedValues = {
        ...values,
        ci_arrvial: formatDateForBackend(values.ci_arrvial),
        ci_depature: formatDateForBackend(values.ci_depature),
        ci_date: formatDateForBackend(values.ci_date),
        ci_refdt: formatDateForBackend(values.ci_refdt),
        ci_cdt: formatDateForBackend(values.ci_cdt),
        ci_mdt: formatDateForBackend(values.ci_mdt),
        ab_cdt: formatDateForBackend(values.ab_cdt),
        ab_mdt: formatDateForBackend(values.ab_mdt),
      };
      const dat: any = isEditMode
        ? await updateCheckIn(formattedValues).unwrap()
        : await insertCheckIn(formattedValues).unwrap();

      const dat1 = {
        cm_code: gdata.company,
        cm_name: gdata.companyname,
        cm_addr1: gdata.addr1 + ', ',
        cm_addr2: gdata.addr2,
        cm_addr3: gdata.city + ' - ' + gdata.pincode,
        cm_phone: 'Phone : ' + gdata.phone,
        cm_taxno1: gdata.tax1no,
        cm_taxno2: gdata.tax2no,
        cm_taxno3: gdata.tax3no,
        cm_logo: buildLogoUrl(gdata.company, gdata.logo),
        cm_roomtype: types,
        cm_room: roomData,
        sr_name: sourceData?.find(v => v.sr_id === Number(dat.ci_source))
          ?.sr_name,
        ci_mode: modeData?.find(v => v.md_id === dat.ci_mode)?.md_name,
      };

      if (!isEditMode) {
        // The check-in was already committed server-side above - a failure
        // building/printing the GRC/receipt from here on must not be reported
        // as "Failed to check in" (that would prompt a retry -> duplicate
        // check-in), so it's isolated in its own try/catch.
        try {
          await CheckinGRC({data: dat}, dat1);
          if (dat.ci_advamt > 0) {
            await AdvanceReceipt({data: dat}, dat1);
          }
        } catch (printError) {
          console.error('Failed to print GRC/receipt:', printError);
          ShowToast('Check-in saved, but GRC/receipt could not be printed', 'info');
        }
      }

      ShowToast(isEditMode ? 'Check-In Updated' : 'Check-In Successful');

      if (!isEditMode) {
        methods.reset(initialValues);
        setSelectedRooms([]);
        setMobile('');
        setFile(null);
        setFile1(null);
        setImage1Uri('');
        setImage2Uri('');
      }
      navigation.navigate('StatusScreen');
    } catch (error: any) {
      console.log(error);
      ShowToast(
        error?.data?.message ||
          error?.message ||
          (isEditMode ? 'Failed to update check-in' : 'Failed to check in'),
        'error',
      );
    }
    setIsSaving(false);
  };

  const handleCaptureImage = async (
    setImageUri: (uri: string) => void,
    setFile: (file: any) => void,
  ) => {
    const result = await launchCamera({
      mediaType: 'photo',
      includeBase64: false,
      quality: 0.8,
      maxWidth: 1280,
      maxHeight: 1280,
      cameraType: isFront ? 'front' : 'back',
    });

    if (result.didCancel) {
      // User cancelled image picker
    } else if (result.errorCode) {
      console.error('ImagePicker Error: ', result.errorMessage);
    } else if (result.assets && result.assets.length > 0) {
      const asset = result.assets[0];

      if (asset?.uri) {
        const file = {
          uri: asset.uri,
          name: asset.fileName || 'photo.jpg',
          type: asset.type || 'image/jpeg',
        };

        setImageUri(asset.uri);
        setFile(file);
        setApiCall(false);
      }
    }
  };

  useEffect(() => {
    if (file && file1) handleGetAddress();
  }, [file, file1]);

  const handleGetAddress = async () => {
    if (apiCall) return;
    if (isSaving) return;
    if (!isTenDigitMobile(methods.getValues('ab_mobile'))) {
      ShowToast('Enter the Mobile No.', 'error');
      return;
    }
    if (!file || !file1) {
      ShowToast('Both images need to be captured.', 'error');
      return;
    }
    setIsSaving(true);
    setApiCall(true);

    const frmData = new FormData();

    frmData.append('files', file);
    frmData.append('files', file1);

    try {
      const addr: any = await getAddressDetails(frmData);

      if (addr?.error) {
        ShowToast('Failed to read ID details. Please try again.', 'error');
        return;
      }

      if (addr?.data?.error) {
        ShowToast(
          addr.data.message || 'Failed to read ID details. Please try again.',
          'error',
        );
        return;
      }

      if (addr && addr.data) {
        const norm = (v: any) => (v ?? '').toString().trim().toLowerCase();

        methods.setValue('ab_name', addr.data.name ?? '');
        methods.setValue('ab_addr1', addr.data.address?.street ?? '');
        methods.setValue(
          'ab_addr2',
          [addr.data.address?.area, addr.data.address?.post]
            .filter(Boolean)
            .join(', '),
        );
        methods.setValue('ab_city', addr.data.address?.city ?? '');
        methods.setValue(
          'ab_state',
          stateData?.find(v => norm(v.st_name) === norm(addr.data.address?.state))
            ?.st_id ?? 0,
        );
        methods.setValue('ab_pincode', addr.data.address?.pinCode ?? '');
        if (moment(addr?.data?.dob).isValid()) {
          const dob = new Date(addr.data.dob);
          methods.setValue('ab_dob', dob);
          methods.setValue('ab_age', moment().diff(moment(dob), 'year'));
        }
        methods.setValue(
          'ab_idtype',
          idtypeData?.find(v => norm(v.it_name) === norm(addr.data.cardType))
            ?.it_id ?? gdata.defidtype,
        );
        methods.setValue('ab_idno', addr.data.cardNo ?? '');
      }
    } catch (error) {
      console.error('Error getting address details:', error);
      ShowToast('Failed to read ID details. Please try again.', 'error');
    } finally {
      setIsSaving(false);
      setApiCall(false);
    }
  };

  return (
    <View style={{ flex: 1, backgroundColor: '#f5f5f5' }}>
      <ScrollView
        contentContainerStyle={{
          padding: 8,
          paddingBottom: 80,
          flexGrow: 1,
          backgroundColor: '#f5f5f5',
        }}
        keyboardShouldPersistTaps="handled"
      >
        <View style={styles.header}>
          <Text style={styles.title}>
            {isEditMode ? 'Edit Check-in' : 'Check-in'}
          </Text>
        </View>
        {isEditMode && isEditCheckinFetching && (
          <View style={styles.loaderContainer}>
            <ActivityIndicator size="large" color="#ff9800" />
          </View>
        )}
        {isEditMode && isEditCheckinError && (
          <Text style={{ color: 'red', padding: 8 }}>
            <T>Failed to load check-in details.</T>
          </Text>
        )}
        <FormProvider {...methods}>
          <Card
            style={{
              padding: 2,
            }}
          >
            <Card.Content>
              <Row>
                <Col>
                  <TextInput
                    name="ab_mobile"
                    label="Mobile No"
                    placeholder={tp("Enter Mobile No")}
                    keyboardType="phone-pad"
                    maxLength={10}
                    onChangeText={text => {
                      const digits = text.replace(/\D/g, '').slice(0, 10);
                      setMobile(digits);
                      methods.setValue('ab_mobile', digits);
                      methods.setValue('ci_mobile', digits);
                    }}
                    autoFocus
                  />
                </Col>
              </Row>
              <Row
                style={{
                  flex: 1,
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <Col style={{ alignItems: 'center' }}>
                  {image1Uri && (
                    <Image
                      source={{ uri: image1Uri }}
                      style={{
                        width: 'auto',
                        height: 100,
                        aspectRatio: 1,
                        borderRadius: 8,
                        marginBottom: 8,
                        resizeMode: 'cover',
                      }}
                    />
                  )}
                  <TouchableOpacity
                    onPress={() => handleCaptureImage(setImage1Uri, setFile)}
                    disabled={isSaving}
                  >
                    <View style={styles.uploadBtn}>
                      <FontAwesome name="camera" size={20} color="#fff" />
                      <Text style={styles.uploadText}><T>Front</T></Text>
                    </View>
                  </TouchableOpacity>
                </Col>

                <Col style={{ alignItems: 'center' }}>
                  {image2Uri && (
                    <Image
                      source={{ uri: image2Uri }}
                      style={{
                        width: 'auto',
                        height: 100,
                        aspectRatio: 1,
                        borderRadius: 8,
                        marginBottom: 8,
                        resizeMode: 'cover',
                      }}
                    />
                  )}
                  <TouchableOpacity
                    onPress={() => handleCaptureImage(setImage2Uri, setFile1)}
                    disabled={isSaving}
                  >
                    <View style={styles.uploadBtn}>
                      <FontAwesome name="camera" size={20} color="#fff" />
                      <Text style={styles.uploadText}><T>Back</T></Text>
                    </View>
                  </TouchableOpacity>
                </Col>
                {/* Guest face photo — shown in edit mode when a signed URL is available */}
                {photoUri ? (
                  <Col style={{ alignItems: 'center' }}>
                    <Image
                      source={{ uri: photoUri }}
                      style={{
                        width: 'auto',
                        height: 100,
                        aspectRatio: 1,
                        borderRadius: 50,
                        marginBottom: 8,
                        resizeMode: 'cover',
                        borderWidth: 2,
                        borderColor: '#146C94',
                      }}
                    />
                    <Text style={{ fontSize: 11, color: '#555', textAlign: 'center' }}><T>Photo</T></Text>
                  </Col>
                ) : null}
                <Col>
                  {isSaving && (
                    <View style={styles.loaderContainer}>
                      <ActivityIndicator size="large" color="#ff9800" />
                    </View>
                  )}
                  {!isSaving && (
                    <TouchableOpacity
                      onPress={handleGetAddress}
                      disabled={isSaving}
                    >
                      <View style={styles.uploadBtn}>
                        <FontAwesome name="id-card" size={20} color="#fff" />
                        <Text style={styles.uploadText}><T>Get Address</T></Text>
                      </View>
                    </TouchableOpacity>
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInput
                    name="ab_name"
                    label="Guest Name"
                    placeholder={tp("Enter Guest Name")}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInput
                    name="ab_addr1"
                    label="Address Line 1"
                    placeholder={tp("Address Line 1")}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInput
                    name="ab_addr2"
                    label="Address Line 2"
                    placeholder={tp("Address Line 2")}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInput name="ab_city" label="City" placeholder={tp("City")} />
                </Col>
                <Col>
                  <TextInput
                    name="ab_pincode"
                    label="Pincode"
                    placeholder={tp("Pincode")}
                    keyboardType="numeric"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInput
                    name="ab_cname"
                    label="Company"
                    placeholder={tp("Company")}
                  />
                </Col>
                <Col>
                  <TextInput
                    name="ab_tax1no"
                    label="GSTIN"
                    placeholder={tp("GSTIN")}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <BTComboBox
                    name="ab_idtype"
                    label="ID-Type"
                    placeholder={tp("ID-Type")}
                    data={idTypes}
                  />
                </Col>
                <Col>
                  <TextInput name="ab_idno" label="ID. #" placeholder={tp("ID. #")} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <BTDateTimePicker name="ab_dob" label="DOB" mode="date" />
                </Col>
                <Col>
                  <TextInput
                    name="ab_age"
                    label="Age"
                    placeholder={tp("Age")}
                    keyboardType="numeric"
                    textAlign="right"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <BTComboBox
                    name={`ci_mode`}
                    label="Room"
                    data={modes}
                    placeholder={tp("Advance Mode")}
                  />
                </Col>
                <Col>
                  <TextInput
                    name="ci_advamt"
                    label="Advance"
                    placeholder={tp("Advance Amount")}
                    keyboardType="numeric"
                    textAlign="right"
                  />
                </Col>
              </Row>
              {detailRows.map((_: any, index: number) => (
                <View key={`room-${index}`} style={styles.detailFragment}>
                  <View style={styles.roomHeader}>
                    <FontAwesome name="bed" size={18} color="#146C94" />
                    <View style={{ flex: 1 }} />
                    {index > 0 && (
                      <FontAwesome
                        name="trash"
                        size={20}
                        color="#d11a2a"
                        onPress={() => {
                          const updated = methods
                            .getValues('ci_details')
                            .filter((_: any, i: number) => i !== index);
                          methods.setValue('ci_details', updated, {
                            shouldDirty: true,
                          });
                          setSelectedRooms(
                            updated
                              .map((detail: any) => Number(detail.cd_room || 0))
                              .filter((roomId: number) => roomId > 0),
                          );
                          setDetailsTick(t => t + 1);
                        }}
                      />
                    )}
                  </View>

                  <Row>
                    <Col>
                      <BTComboBox
                        name={`ci_details.${index}.cd_room`}
                        label="Room"
                        data={rooms?.filter(
                          room =>
                            !selectedRooms.includes(room.id) ||
                            room.id ===
                              methods.getValues(`ci_details.${index}.cd_room`),
                        )}
                        placeholder={tp("Select Room")}
                        onValueChange={(roomId: any) => {
                          let updatedRooms = [...selectedRooms];

                          const previousRoom = methods.getValues(
                            `ci_details.${index}.cd_room`,
                          );
                          if (previousRoom) {
                            updatedRooms = updatedRooms.filter(
                              id => id !== previousRoom,
                            );
                          }

                          if (roomId) updatedRooms.push(Number(roomId));

                          setSelectedRooms(updatedRooms);
                          methods.setValue(
                            `ci_details.${index}.cd_room`,
                            roomId,
                            { shouldDirty: true },
                          );

                          const matched = tariffData?.find(
                            t =>
                              t.rf_roomtype ===
                              roomData?.find(v => v.rm_id === Number(roomId))
                                ?.rm_roomtype,
                          );

                          if (matched) {
                            methods.setValue(
                              `ci_details.${index}.cd_roomtype`,
                              matched.rt_id.toString(),
                            );
                            methods.setValue(
                              `ci_details.${index}.cd_male`,
                              matched.rf_occ.toString(),
                            );
                            methods.setValue(
                              `ci_details.${index}.cd_female`,
                              '0',
                            );
                            methods.setValue(
                              `ci_details.${index}.cd_child`,
                              '0',
                            );
                            methods.setValue(
                              `ci_details.${index}.cd_adult`,
                              matched.rf_occ.toString(),
                            );
                            methods.setValue(
                              `ci_details.${index}.cd_earate`,
                              '0',
                            );
                            applyRentalType(index, 'D', matched);

                            calculateNetAmount();
                          }
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <BTComboBox
                        name={`ci_details.${index}.cd_rentaltype`}
                        label="Type"
                        data={getAvailableRentalTypesForRoomType(
                          Number(methods.getValues(`ci_details.${index}.cd_roomtype`)) || 0,
                        )}
                        placeholder={tp("Select Type")}
                        onValueChange={(rentalType: any) => {
                          const roomTypeId = Number(
                            methods.getValues(`ci_details.${index}.cd_roomtype`),
                          );
                          const matched = tariffData?.find(t => t.rt_id === roomTypeId);
                          applyRentalType(index, rentalType || 'D', matched);
                          calculateNetAmount();
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <TextInput
                        name={`ci_details.${index}.cd_male`}
                        label="Male"
                        placeholder={tp("Male")}
                        keyboardType="numeric"
                        textAlign="right"
                      />
                    </Col>
                    <Col>
                      <TextInput
                        name={`ci_details.${index}.cd_female`}
                        label="Female"
                        placeholder={tp("Female")}
                        keyboardType="numeric"
                        textAlign="right"
                      />
                    </Col>
                    <Col>
                      <TextInput
                        name={`ci_details.${index}.cd_child`}
                        label="Child"
                        placeholder={tp("Child")}
                        keyboardType="numeric"
                        textAlign="right"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <TextInput
                        name={`ci_details.${index}.cd_rate`}
                        label="Tariff"
                        placeholder={tp("Room Tariff")}
                        keyboardType="numeric"
                        textAlign="right"
                      />
                    </Col>
                    <Col>
                      <TextInput
                        name={`ci_details.${index}.cd_earate`}
                        label="Extra Bed"
                        placeholder={tp("Extra Bed")}
                        keyboardType="numeric"
                        textAlign="right"
                      />
                    </Col>
                    <Col>
                      <TextInput
                        name={`ci_details.${index}.cd_amt`}
                        label="Net"
                        placeholder={tp("Net")}
                        keyboardType="numeric"
                        textAlign="right"
                      />
                    </Col>
                  </Row>
                </View>
              ))}
              <Row style={{ justifyContent: 'center', marginTop: 8 }}>
                <FontAwesome
                  name="plus-circle"
                  size={30}
                  color="#146C94"
                  onPress={handleAddRoom}
                />
              </Row>
              <Row>
                <Col>
                  <BTComboBox
                    name="ci_employee"
                    label={foSetting?.se_hkempcheckin === 1 ? 'HK Employee *' : 'HK Employee'}
                    data={employees}
                    placeholder={tp("Select HK Employee")}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInput
                    name="ci_remarks"
                    label={foSetting?.se_manualreceipt === 1 ? 'Remarks / Manual Ref *' : 'Remarks'}
                    placeholder={tp("Remarks / Manual Ref")}
                  />
                </Col>
              </Row>
              <Divider style={{ marginVertical: 12 }} />
              <Row>
                <Col>
                  <BTButton
                    title={isEditMode ? 'Update' : 'Save'}
                    color="#146C94"
                    onPress={methods.handleSubmit(onSubmit, onInvalidSubmit)}
                    onLongPress={() => {}}
                    disabled={isSaving || isEditCheckinFetching}
                  />
                </Col>
                <Col>
                  <BTButton
                    title="Cancel"
                    color="#146C94"
                    onPress={() => {
                      methods.reset(initialValues);
                      setSelectedRooms([]);
                      setMobile('');
                      setFile(null);
                      setFile1(null);
                      setImage1Uri('');
                      setImage2Uri('');
                      setPhotoUri('');
                      navigation.navigate('StatusScreen');
                    }}
                    onLongPress={() => {}}
                  />
                </Col>
              </Row>
            </Card.Content>
          </Card>
        </FormProvider>
      </ScrollView>
    </View>
  );
};

export default CheckInForm;
